/*
 * qr-landing.js
 * Loaded only by sections/qr-landing.liquid — never included on any
 * other template, so it has zero effect anywhere else in the theme.
 *
 * Progressive enhancement only. The page is fully usable and visible
 * with this script blocked, absent, or slow: every element it touches
 * is already visible by default (see section-qr-landing.css), and
 * both actions are plain <a href> links that need no JS to work.
 *
 * All this does is opt elements into a brief reveal transition, then
 * clear it on the next frame. It respects prefers-reduced-motion via
 * CSS (the --js class it adds has no visual effect unless the
 * no-preference media query in section-qr-landing.css matches).
 */
(function () {
  var roots = document.querySelectorAll('.qr-landing[data-qr-landing]');

  roots.forEach(function (root) {
    root.classList.add('qr-landing--js');

    // Double rAF: let the browser paint the pre-reveal state on one
    // frame before transitioning on the next, so the transition
    // actually runs instead of the end state applying instantly.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('qr-landing--revealed');
      });
    });
  });
})();
